import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Stack, Box, Tooltip, Typography, IconButton } from "@mui/material";
const SectionCardHeader = ({
  icon,
  title,
  collapsed,
  expanded,
  setExpanded,
  actions,
  titleInfo,
  titleInfoNode,
  showAdminLock,
  adminLockLabel = "관리자용"
}) => {
  const { brand, gray, purple } = useColors();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Stack,
      {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        sx: { flex: { mobile: "1 1 auto", tablet: 1 }, minWidth: 0 },
        children: [
          icon ? /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                display: "inline-flex",
                alignItems: "center",
                color: brand[600],
                flexShrink: 0
              },
              children: icon
            }
          ) : null,
          /* @__PURE__ */ jsx(Tooltip, { title, children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body1",
              noWrap: true,
              sx: {
                fontWeight: 600,
                color: gray[800],
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              children: title
            }
          ) }),
          showAdminLock && /* @__PURE__ */ jsx(Tooltip, { title: adminLockLabel, children: /* @__PURE__ */ jsx(
            LockOutlinedIcon,
            {
              sx: {
                fontSize: 18,
                color: purple[500],
                ml: 0.25,
                flexShrink: 0
              },
              "aria-label": adminLockLabel
            }
          ) }),
          titleInfo && /* @__PURE__ */ jsx(Box, { sx: { mt: 0.5, flexShrink: 0 }, children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              noWrap: true,
              sx: { fontWeight: 400, color: gray[500] },
              children: titleInfo.split(/(\d+)/).map((part, index) => {
                if (/^\d+$/.test(part)) {
                  return /* @__PURE__ */ jsx(
                    Box,
                    {
                      component: "strong",
                      sx: { color: brand[500], fontWeight: 600 },
                      children: part
                    },
                    index
                  );
                }
                return part;
              })
            }
          ) }),
          titleInfoNode && /* @__PURE__ */ jsx(Box, { sx: { flexShrink: 0, minWidth: 0 }, children: titleInfoNode }),
          collapsed && /* @__PURE__ */ jsx(
            IconButton,
            {
              size: "small",
              onClick: () => setExpanded(!expanded),
              sx: {
                ml: 0.5,
                color: brand[700],
                flexShrink: 0,
                transform: expanded ? "rotate(360deg)" : "rotate(270deg)",
                transition: "transform 0.2s ease"
              },
              children: /* @__PURE__ */ jsx(ExpandMoreIcon, { fontSize: "small" })
            }
          )
        ]
      }
    ),
    actions ? /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          // 모바일에서 다음 줄로 내려와도 넘치면 카드 너비 안에서 버튼끼리 줄바꿈
          flexShrink: { mobile: 1, tablet: 0 },
          flexWrap: { mobile: "wrap", tablet: "nowrap" },
          minWidth: 0,
          justifyContent: "flex-end",
          ml: "auto"
        },
        children: actions
      }
    ) : null
  ] });
};
export {
  SectionCardHeader
};
